import { Dayjs } from 'dayjs';

/** @description 스토리지 타입 */
export enum WEB_STORAGE_TYPE {
  LOCAL_STORAGE = 'localStorage',
  SESSION_STORAGE = 'sessionStorage',
}

/** @description 웹 스토리지를 제어하는 모듈 */
export const webStorageService = (webStorageType: WEB_STORAGE_TYPE) => {
  const SKIP_CHANGE_PASSWORD_DATE = 'skipChangePasswordDate';
  const ALREADY_SHOW_SAFETY_EDUCATION_MODAL = 'alreadyShowSafetyEducationModal';

  const WEB_STORAGE = { localStorage, sessionStorage };
  const SELECTED_STORAGE = WEB_STORAGE[webStorageType];

  const getStorage = <T>(item: string): T => JSON.parse(String(SELECTED_STORAGE.getItem(item)));

  const setStorage = <T>(item: string, value: T): void => SELECTED_STORAGE.setItem(item, JSON.stringify(value));

  const getSkipChangePasswordDate = (): Dayjs => getStorage<Dayjs>(SKIP_CHANGE_PASSWORD_DATE);

  const setSkipChangePasswordDate = (date: Dayjs) => setStorage(SKIP_CHANGE_PASSWORD_DATE, date);

  const getIsAlreadyShowSafetyEducationModal = () => !!getStorage(ALREADY_SHOW_SAFETY_EDUCATION_MODAL);

  const setIsAlreadyShowSafetyEducationModal = (isFirstShow: string) =>
    setStorage(ALREADY_SHOW_SAFETY_EDUCATION_MODAL, isFirstShow);

  return {
    getSkipChangePasswordDate,
    setSkipChangePasswordDate,
    getIsAlreadyShowSafetyEducationModal,
    setIsAlreadyShowSafetyEducationModal,
  };
};
